import { useContext } from "react";
import { AnfrageWizardContext } from "@/pages/anfragen/anfrageWizardContextValue";

export function useAnfrageWizard() {
  const ctx = useContext(AnfrageWizardContext);
  if (!ctx) {
    throw new Error("useAnfrageWizard() muss innerhalb von <AnfrageWizardProvider> verwendet werden.");
  }
  return ctx;
}
